module.exports = __webpack_public_path__ + "static/media/laddu_front_of_sun.910f950f.gif";